import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import CardWithButton from "../../../../../components/Info/CardWithButton";
import image from "../../../../../assets/images/headerLogo.svg";
import teklogo from "../../../../../assets/images/tektree-logo-png-1.svg";
import SetupModel from "./Integration/SetupModel";
import { CustomSearch, FormFieldSet } from "../../../../../components";
import foundit from "../../../../../assets/images/Marketplace/foundit.svg";
import jora from "../../../../../assets/images/Marketplace/jora.svg";
import linkedin from "../../../../../assets/images/Marketplace/linkedin.svg";
import monster from "../../../../../assets/images/Marketplace/monster.svg";
import naukari from "../../../../../assets/images/Marketplace/naukari.svg";
import shine from "../../../../../assets/images/Marketplace/shine.svg";
import zipRecruiters from "../../../../../assets/images/Marketplace/zipRecruiters.svg";
const options = [
  { label: "VOIP", value: "VOIP" },
  { label: "VMS", value: "VMS" },
  { label: "Job Board", value: "Job Board" },
  { label: "Bulk Email", value: "Bulk Email" },
  { label: "WhatsApp", value: "WhatsApp" },
  { label: "SMS", value: "SMS" },
  { label: "AI (Beta)", value: "AI" },
  { label: "Productivity", value: "Productivity" },
  { label: "Assessment Tools", value: "Assessment Tools" },
  { label: "View Interview", value: "View Interview" },
  { label: "Background Check", value: "Background Check" },
  { label: "Bulk Email", value: "Bulk Email" },
];

const Integration = () => {
  // const [options, setOptions] = useState([]);
  const [checkMultiSelect, setCheckMultiSelect] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [options, setOptions] = useState([]);
  const jobBoardDetails = useSelector(
    (state) => state.settings.configurations.integrations.JobBoardDetails
  );

  // function to check if a given integration is already added
  const isIntegrationAdded = (category, type) => {
    return jobBoardDetails.some(
      (item) => item.category === Number(category) && item.type === type
    );
  };

  // useEffect(() => {
  //   setOptions([
  //     { label: "VOIP", value: "VOIP" },
  //     { label: "VMS", value: "VMS" },
  //     { label: "Job Board", value: "Job Board" },
  //     { label: "WhatsApp", value: "WhatsApp" },
  //     { label: "SMS", value: "SMS" },
  //     { label: "AI (Beta)", value: "AI" },
  //     { label: "Productivity", value: "Productivity" },
  //     { label: "Assessment Tools", value: "Assessment Tools" },
  //     { label: "View Interview", value: "View Interview" },
  //     { label: "Background Check", value: "Background Check" },
  //     { label: "Bulk Email", value: "Bulk Email" },
  //   ]);
  // }, []);
  useEffect(() => {
    setOptions([
      { label: "VOIP", value: 1 },
      { label: "VMS", value: 2 },
      { label: "Job Board", value: 3 },
      { label: "WhatsApp", value: 4 },
      { label: "SMS", value: 5 },
      { label: "AI (Beta)", value: 6 },
      { label: "Productivity", value: 7 },
      { label: "Assessment Tools", value: 8 },
      { label: "View Interview", value: 9 },
      { label: "Background Check", value: 10 },
      { label: "Bulk Email", value: 11 },
    ]);
  }, []);
  const categoryMap = {
    1: "VOIP",
    2: "VMS",
    3: "Job Board",
    4: "WhatsApp",
    5: "SMS",
    6: "AI",
    7: "Productivity",
    8: "Assessment Tools",
    9: "View Interview",
    10: "Background Check",
    11: "Bulk Email"
  };

  const data = {
    VOIP: [
      {
        title: "VOIP Office CRM",
        description:
          "Please request the Monster pre-presentative provide the API access  withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "ZOOM",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "Knowlarity",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "Vonage",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "Vitel Global",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "3cx URL",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "VOX",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "RingCentral",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "Plivo",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
    ],
    VMS: [
      {
        title: "VOIP Office CRM",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "Convendis",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "iLabour 360",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
    ],
    "Job Board": [
      {
        type: 1,
        title: <img src={monster} alt="Header Logo" className="w-fit h-8" />,
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel category={3} type={1} />,
      },
      {
        type: 2,
        title: <img src={shine} alt="Tek Logo" className="w-fit h-8" />,
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        type: 3,
        title: <img src={naukari} alt="Header Logo" className="w-fit h-8" />,
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: <img src={linkedin} alt="Header Logo" className="w-fit h-8" />,
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: (
          <img src={zipRecruiters} alt="Header Logo" className="w-fit h-8" />
        ),
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: <img src={jora} alt="Header Logo" className="w-fit h-8" />,
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
    ],
    "Bulk Email": [
      {
        type: 1,
        title: "G-suite",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        type: 2,
        title: "Outlook",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        type: 3,
        title: "Mailgun",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        type: 4,
        title: "AWS SES",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        type: 5,
        title: "Instantly",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
    ],
    WhatsApp: [
      {
        title: "VOIP Office CRM",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "Convendis",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "iLabour 360",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
    ],
    SMS: [
      {
        title: "VOIP Office CRM",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "Convendis",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "iLabour 360",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
    ],
    AI: [
      {
        title: "VOIP Office CRM",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "Convendis",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "iLabour 360",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
    ],
    Productivity: [
      // {
      //   title: "Productivity Tool 1",
      //   description:
      //     "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
      //   setup: <SetupModel />,
      // },
      // {
      //   title: "Productivity Tool 2",
      //   description:
      //     "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
      //   setup: <SetupModel />,
      // },
      // {
      //   title: "Productivity Tool 3",
      //   description:
      //     "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
      //   setup: <SetupModel />,
      // },
      {
        type: 1,
        title: "Google Search API",
        description: "Short Description",
        setup: <SetupModel />,
      },
    ],
    "Assessment Tools": [
      {
        title: "Assessment Tool 1",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "Assessment Tool 2",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "Assessment Tool 3",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
    ],
    "View Interview": [
      {
        title: "View Interview 1",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "View Interview 2",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "View Interview 3",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
    ],
    "Background Check": [
      {
        title: "Background Check 1",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "Background Check 2",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
      {
        title: "Background Check 3",
        description:
          "Please request the Monster pre-presentative provide the API access withg registered name to configure and",
        setup: <SetupModel />,
      },
    ],
  };

  const filteredOptions =
    searchValue?.length > 0
      ? options.filter((value) =>
          value["label"].toLowerCase().includes(searchValue.toLowerCase())
        )
      : options;

  const handleSelect = (optionValue) => {
    let newSelected;
    if (checkMultiSelect.includes(optionValue)) {
      newSelected = checkMultiSelect.filter((v) => v !== optionValue);
    } else {
      newSelected = [...checkMultiSelect, optionValue];
    }
    setCheckMultiSelect(newSelected);
  };

  const handleSelectAll = () => {
    if (checkMultiSelect.length === options.length) {
      setCheckMultiSelect([]);
    } else {
      setCheckMultiSelect(options.map((opt) => opt["value"]));
    }
  };

  const isOptionSelected = (option) =>
    checkMultiSelect.includes(option["value"]);

  // return (

  //   <div className="grid grid-cols-4 overflow-hidden">
  //     <div className="col-span-1 p-3">
  //       <FormFieldSet
  //         type="multiSelect"
  //         title="Select"
  //         placeholder="Select Options"
  //         options={options}
  //         value={checkMultiSelect}
  //         onChange={setCheckMultiSelect}
  //         showSelectAll={true}
  //       />
  //     </div>

  //     <div className="col-span-3 p-3">
  //       <div className="h-[75vh] border border-gray-100 rounded-md p-4 flex flex-col flex-1 overflow-auto shadow-sm">
  //         {/* {checkMultiSelect && checkMultiSelect.length === 0
  //           ? // ? Object.keys(data).map((category) => (
  //             //     <div key={category} className="mb-6">
  //             //       <h5 className="mb-4 font-medium">Selected {category}</h5>
  //             //       <div className="grid grid-cols-3 gap-4 ">
  //             //         {data[category] &&
  //             //           data[category].map((item, index) => (
  //             //             <CardWithButton
  //             //               key={index}
  //             //               title={item.title}
  //             //               description={item.description}
  //             //               category={category}
  //             //               setup={item.setup}
  //             //             />
  //             //           ))}
  //             //       </div>
  //             //     </div>
  //             //   ))
  //             Object.keys(data).map((category) => (
  //               <div key={category} className="mb-6">
  //                 <h5 className="mb-4 font-medium">Selected {category}</h5>
  //                 <div className="grid grid-cols-3 gap-4">
  //                   {data[category]?.map((item, index) => (
  //                     <CardWithButton
  //                       key={index}
  //                       title={item.title}
  //                       description={item.description}
  //                       category={category} // here "category" exists
  //                       setup={
  //                         <SetupModel
  //                           category={category} // use the "category" from map
  //                           type={item.type || index + 1}
  //                         />
  //                       }
  //                     />
  //                   ))}
  //                 </div>
  //               </div>
  //             ))
  //           : // : checkMultiSelect.map((key, index) => (
  //             //     <div className="mb-6" key={index}>
  //             //       <h5 className="mb-4 font-normal">Selected {key}</h5>
  //             //       <div className="grid grid-cols-3 gap-4 ">
  //             //         {data[key] &&
  //             //           data[key].map((item, index) => (
  //             //             <CardWithButton
  //             //               key={index}
  //             //               title={item.title}
  //             //               description={item.description}
  //             //               category={key}
  //             //               setup={item.setup}
  //             //             />
  //             //           ))}
  //             //       </div>
  //             //     </div>
  //             //   ))}
  //             // checkMultiSelect.map((numVal, index) => {
  //             //   const key = categoryMap[numVal]; // map numeric value → category name
  //             //   return (
  //             //     <div className="mb-6" key={index}>
  //             //       <h5 className="mb-4 font-normal">Selected {key}</h5>
  //             //       <div className="grid grid-cols-3 gap-4">
  //             //         {data[key]?.map((item, idx) => (
  //             //           <CardWithButton
  //             //             key={idx}
  //             //             title={item.title}
  //             //             description={item.description}
  //             //             category={key}
  //             //             setup={item.setup}
  //             //           />
  //             //         ))}
  //             //       </div>
  //             //     </div>
  //             //   );
  //             // })}
  //             checkMultiSelect.map((numVal, index) => {
  //               const category = categoryMap[numVal]; // ← use this name
  //               return (
  //                 <div className="mb-6" key={index}>
  //                   <h5 className="mb-4 font-normal">Selected {category}</h5>
  //                   <div className="grid grid-cols-3 gap-4">
  //                     {data[category]?.map((item, idx) => (
  //                       <CardWithButton
  //                         key={idx}
  //                         title={item.title}
  //                         description={item.description}
  //                         category={category} // use "category"
  //                         setup={
  //                           <SetupModel
  //                             category={category} // pass category
  //                             type={item.type || idx + 1}
  //                           />
  //                         }
  //                       />
  //                     ))}
  //                   </div>
  //                 </div>
  //               );
  //             })} */}
  //         <div className="col-span-3 p-3">
  //           <div className="h-[75vh] border border-gray-100 rounded-md p-4 flex flex-col flex-1 overflow-auto shadow-sm">
  //             {checkMultiSelect && checkMultiSelect.length === 0
  //               ? Object.keys(data).map((category) => (
  //                   <div key={category} className="mb-6">
  //                     <h5 className="mb-4 font-medium">Selected {category}</h5>
  //                     <div className="grid grid-cols-3 gap-4">
  //                       {data[category]?.map((item, index) => (
  //                         <CardWithButton
  //                           key={index}
  //                           title={item.title}
  //                           description={item.description}
  //                           category={category}
  //                           setup={
  //                             <SetupModel
  //                               category={Object.keys(categoryMap).find(
  //                                 (key) => categoryMap[key] === category
  //                               )} // numeric category for payload
  //                               type={item.type || index + 1}
  //                             />
  //                           }
  //                         />
  //                       ))}
  //                     </div>
  //                   </div>
  //                 ))
  //               : // : checkMultiSelect.map((numVal, index) => {
  //                 //     const categoryName = categoryMap[numVal];
  //                 //     const numericCategory = Number(key); // map numeric value → category string
  //                 //     return (
  //                 //       <div className="mb-6" key={index}>
  //                 //         <h5 className="mb-4 font-normal">
  //                 //           Selected {categoryName}
  //                 //         </h5>
  //                 //         <div className="grid grid-cols-3 gap-4">
  //                 //           {data[categoryName]?.map((item, idx) => (
  //                 //             <CardWithButton
  //                 //               key={idx}
  //                 //               title={item.title}
  //                 //               description={item.description}
  //                 //               category={numericCategory}
  //                 //               setup={
  //                 //                 <SetupModel
  //                 //                   category={numericCategory} // numeric value for payload
  //                 //                   type={item.type || idx + 1}
  //                 //                 />
  //                 //               }
  //                 //             />
  //                 //           ))}
  //                 //         </div>
  //                 //       </div>
  //                 //     );
  //                 //   })}
  //                 checkMultiSelect.map((numVal, index) => {
  //                   const categoryName = categoryMap[numVal]; // Get string name (like "Job Board")
  //                   const numericCategory = Number(numVal); //  fix — convert current value, not undefined key
  //                   return (
  //                     <div className="mb-6" key={index}>
  //                       <h5 className="mb-4 font-normal">
  //                         Selected {categoryName}
  //                       </h5>
  //                       <div className="grid grid-cols-3 gap-4">
  //                         {data[categoryName]?.map((item, idx) => (
  //                           <CardWithButton
  //                             key={idx}
  //                             title={item.title}
  //                             description={item.description}
  //                             category={numericCategory}
  //                             setup={
  //                               <SetupModel
  //                                 category={numericCategory} //  numeric value now passes correctly
  //                                 type={item.type || idx + 1}
  //                               />
  //                             }
  //                           />
  //                         ))}
  //                       </div>
  //                     </div>
  //                   );
  //                 })}
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );

  return (
    <div className="grid grid-cols-4 flex-1 gap-3 overflow-hidden pb-2 pt-3 max-w-full">
      <div className="col-span-1 border border-gray-100 rounded-md p-2 overflow-auto shadow-sm">
        <div className="mx-2 mt-2">
          <CustomSearch
            placeholder="Search"
            value={searchValue}
            onChange={(key, value) => setSearchValue(value)}
            rounded="rounded-full"
          />
          <hr className="mt-2 text-gray-300" />
        </div>
        <ul className="p-2 space-y-1">
          {searchValue.length == 0 && (
            <li
              className="flex items-center p-2 rounded cursor-pointer hover:bg-primary-50"
              onClick={handleSelectAll}
            >
              <input
                type="checkbox"
                checked={checkMultiSelect.length === options.length}
                readOnly
                className="mr-2 cursor-pointer appearance-none h-4 w-4 border border-gray-300 rounded-sm flex-shrink-0 checked:bg-primary checked:border-primary checked:after:content-['✓'] 
                      checked:after:text-white checked:after:flex checked:after:items-center checked:after:justify-center checked:after:h-full checked:after:w-full "
              />
              <span>All</span>
            </li>
          )}

          {filteredOptions.map((opt) => (
            <li
              key={opt["value"]}
              className="flex items-center p-2 rounded cursor-pointer hover:bg-primary-50"
              onClick={() => handleSelect(opt["value"])}
            >
              <input
                type="checkbox"
                checked={isOptionSelected(opt)}
                readOnly
                className="mr-2 cursor-pointer appearance-none h-4 w-4 border border-gray-300 rounded-sm flex-shrink-0 checked:bg-primary checked:border-primary checked:after:content-['✓'] 
                      checked:after:text-white checked:after:flex checked:after:items-center checked:after:justify-center checked:after:h-full checked:after:w-full"
              />
              <span className={`flex-1`}>{opt["label"]}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* <div className="col-span-3 border border-gray-100 rounded-md p-4 flex flex-col overflow-auto shadow-sm">
        {checkMultiSelect && checkMultiSelect.length === 0
          ? Object.keys(data).map((category) => (
              <div key={category} className="mb-6">
                <h5 className="mb-4 font-medium">Selected {category}</h5>
                <div className="grid grid-cols-3 gap-4 ">
                  {data[category] &&
                    data[category].map((item, index) => (
                      <CardWithButton
                        key={index}
                        title={item.title}
                        description={item.description}
                        category={category}
                        setup={item.setup}
                      />
                    ))}
                </div>
              </div>
            ))
          : checkMultiSelect.map((key, index) => (
              <div className="mb-6" key={index}>
                <h5 className="mb-4 font-medium">Selected {key}</h5>
                <div className="grid grid-cols-3 gap-4 ">
                  {data[key] &&
                    data[key].map((item, index) => (
                      <CardWithButton
                        key={index}
                        title={item.title}
                        description={item.description}
                        category={key}
                        setup={item.setup}
                      />
                    ))}
                </div>
              </div>
            ))}
      </div> */}
      <div className="col-span-3 border border-gray-100 rounded-md p-4 flex flex-col overflow-auto shadow-sm">
        {/* {checkMultiSelect && checkMultiSelect.length === 0
          ? Object.keys(data).map((category) => (
              <div key={category} className="mb-6">
                <h5 className="mb-4 font-medium">Selected {category}</h5>
                <div className="grid grid-cols-3 gap-4">
                  {data[category]?.map((item, index) => (
                    <CardWithButton
                      key={index}
                      title={item.title}
                      description={item.description}
                      category={
                        Object.keys(categoryMap).find(
                          (key) => categoryMap[key] === category
                        ) // numeric category for payload
                      }
                      setup={
                        <SetupModel
                          category={Object.keys(categoryMap).find(
                            (key) => categoryMap[key] === category
                          )} // numeric category
                          type={item.type || index + 1}
                        />
                      }
                    />
                  ))}
                </div>
              </div>
            )) */}
            {checkMultiSelect && checkMultiSelect.length === 0
            ? Object.keys(data).map((category) => {
                const categoryNum = Number(
                  Object.keys(categoryMap).find(
                    (key) => categoryMap[key] === category
                  )
                );

                return (
                  <div key={category} className="mb-6">
                    <h5 className="mb-4 font-medium">Selected {category}</h5>
                    <div className="grid grid-cols-3 gap-4">
                      {data[category]?.map((item, idx) => {
                        const typeValue = item.type ?? idx + 1;

                        return (
                          <CardWithButton
                            key={`${category}-${idx}`}
                            title={item.title}
                            description={item.description}
                            category={categoryNum}
                            type={typeValue}
                            setup={
                              <SetupModel
                                category={categoryNum}
                                type={typeValue}
                              />
                            }
                          />
                        );
                      })}
                    </div>
                  </div>
                );
              })
          : checkMultiSelect.map((numVal, index) => {
              const categoryName = categoryMap[numVal]; // e.g. 3 → "Job Board"
              return (
                <div className="mb-6" key={index}>
                  <h5 className="mb-4 font-medium">Selected {categoryName}</h5>
                  <div className="grid grid-cols-3 gap-4">
                    {data[categoryName]?.map((item, idx) => (
                      <CardWithButton
                        key={idx}
                        title={item.title}
                        description={item.description}
                        category={numVal}
                        type={item.type || idx + 1} //  numeric category for payload
                        setup={
                          <SetupModel
                            category={numVal} // numeric value passed here
                            type={item.type || idx + 1}
                          />
                        }
                        // setup={item.setup}
                      />
                    ))}
                  </div>
                </div>
              );
            })}
      </div>
    </div>
  );
};

export default Integration;
